import { useState } from 'react';
import Link from 'next/link';

import Button, { ButtonProps } from '@core/design-system/button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import { MdCompareArrows } from '@react-icons/all-files/md/MdCompareArrows';
import { DEFAULT_ROUTES } from '@mais-retorno-front/constants/routes';

export const ComparisonButton = ({
  benchmark,
  fundCnpj,
  buttonProps,
}: ComparisonButtonProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const open = Boolean(anchorEl);
  const id = open ? 'comparison-popover' : undefined;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        variant="contained"
        color="secondary"
        endIcon={<MdCompareArrows />}
        onClick={handleClick}
        id="comparison-buton"
        title="Comparar esse fundo"
        sx={{
          textTransform: 'none',
          width: { xs: '100%', sm: buttonProps?.fullWidth ? '100%' : 'auto' },
        }}
        {...buttonProps}
      >
        Comparar
      </Button>
      <Menu
        id={id}
        anchorEl={anchorEl}
        onClose={handleClose}
        open={open}
        style={{ marginTop: '5px' }}
      >
        <MenuItem>
          <Link
            prefetch={false}
            href={`${DEFAULT_ROUTES.comparisonFund}/otimo/${benchmark}/${fundCnpj}`}
            rel="noopener"
          >
            <ListItemText>Comparador de Fundos</ListItemText>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            prefetch={false}
            href={`${DEFAULT_ROUTES.assetsComparison}?p=otimo&a=${fundCnpj}:fi,${benchmark}:idx`}
            passHref
            rel="noopener"
          >
            Comparador de Ativos
          </Link>
        </MenuItem>
      </Menu>
    </>
  );
};

interface ComparisonButtonProps {
  benchmark: string;
  fundCnpj: number;
  buttonProps?: ButtonProps;
}
